import angular from 'angular'

import movement from './movement/movement.module'
import train from './train/train.module'
import wagon from './wagon/wagon.module'

const name = 'trains'

angular.module(name, [
  movement,
  train,
  wagon,
])

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/trains.module.js